import React, { useState, useEffect } from "react";
import AppointmentSearchPanel from "./appointment-search-panel.jsx";
import AppointmentsList from "./appointments-list.jsx";
import useAppointmentsManagement from "../../../hooks/appoitnment/useAppointmentsManagement.jsx";
import UpdateAppointmentModal from "./UpdateAppointmentModal.jsx";
import AlertMessage from "../../../components/AlertMessage.jsx";
import Breadcrumb from "../../../components/Breadcrumb";

import "./appointments-Management.css";
const AppointmentsManagement = () => {
  const {
    barberList,
    selectedBarber,
    selectedStatus,
    selectCustomer,
    reference,
    customerList,
    appointments,
    statusList,
    date,
    showMessage,
    setShowMessage,
    message,
    setSelectedStatus,
    setSelectCustomer,
    setSelectedBarber,
    setReference,
    setDate,
    fetchAppointments,
    onEditClick,
    showUpdateAppointment,
    onCloseUpdateAppointment,
    updateAppointment,
    onSaveClick,
  } = useAppointmentsManagement();

  if (barberList == null || customerList == null) {
    return <div>loading...</div>;
  }
  return (
    <div className="content">
      <div className="content-block">
        <Breadcrumb parent="Appointments" child="All Appointments" />
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <AppointmentSearchPanel
              barberList={barberList}
              selectedBarber={selectedBarber}
              selectedStatus={selectedStatus}
              statusList={statusList}
              selectCustomer={selectCustomer}
              reference={reference}
              customerList={customerList}
              date={date}
              setSelectedStatus={setSelectedStatus}
              setSelectCustomer={setSelectCustomer}
              setSelectedBarber={setSelectedBarber}
              setReference={setReference}
              setDate={setDate}
              onSearch={fetchAppointments}
            />
            <UpdateAppointmentModal
              isOpen={showUpdateAppointment}
              appointment={updateAppointment}
              customerList={customerList}
              onSave={onSaveClick}
              onClose={onCloseUpdateAppointment}
              statusList={statusList}
            />
            <AppointmentsList
              appointments={appointments}
              onEditClick={onEditClick}
            />
            {showMessage && (
              <AlertMessage
                key={message.text}
                setVisible={setShowMessage}
                message={message.text}
                type={message.type}
                duration={4000}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentsManagement;
